module.exports = __webpack_public_path__ + "img/store_Foodpanda.a74073bd.svg";